import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SpeakerService } from '../speaker.service';

declare let $;

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ResourcesComponent implements OnInit {
	
	constructor(private speakerSrv : SpeakerService) { }

	ngOnInit() {
	
	}
	
	replaceIframe() {
		setTimeout(() => {
			let iframe = document.getElementById('iframe');
			
			console.log(iframe);
			
			// let doc = iframe.contentDocument || iframe.contentWindow.document;
			//
			// doc = $(doc);
			//
			// let body = doc.find('div#content');
			// let css = doc.find('head > link[rel="stylesheet"][href$="/css/main.css?r=20190306"]');
			//
			// console.log(body, css);
			
			// .contents();
			// let body = contents.find('div#content');
			// let css = contents.find('head > link[rel="stylesheet"][href$="/css/main.css?r=20190306"]');
			// contents.find('html').replaceWith(body);
			// contents.find('div#content').prepend(css);
			// console.log('replaced');
			// console.log(contents);
		}, 700);
		console.log('called');
	}
}



// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/resources/resources.component.ts